import apiClient from './client';

export const partsApi = {
  /**
   * Get part details with materials and calculations
   */
  getPartDetails: async (partId, options = {}) => {
    const response = await apiClient.get(`/api/v1/parts/${partId}`, {
      params: options.programId ? { program_id: options.programId } : {}
    });
    return response.data;
  },

  /**
   * Get all Program 360 contexts where a Part Master is used
   */
  getPartContexts: async (partId) => {
    const response = await apiClient.get(`/api/v1/parts/${partId}/contexts`);
    return response.data;
  },

  /**
   * Add a material to a part
   */
  addMaterial: async (partId, materialData) => {
    const response = await apiClient.post(`/api/v1/parts/${partId}/materials`, materialData);
    return response.data;
  },

  /**
   * Delete a material from a part
   */
  deleteMaterial: async (partId, materialId) => {
    const response = await apiClient.delete(`/api/v1/parts/${partId}/materials/${materialId}`);
    return response.data;
  },

  /**
   * Calculate tariff for a part
   */
  calculateTariff: async (partId) => {
    const response = await apiClient.post(`/api/v1/parts/${partId}/calculate`);
    return response.data;
  },

  /**
   * Get annual and lifetime impact for a part
   */
  getAnnualLifetimeImpact: async (partId) => {
    const response = await apiClient.get(`/api/v1/parts/${partId}/impact`);
    return response.data;
  },

  /**
   * Update part information
   */
  updatePart: async (partId, partData) => {
    const response = await apiClient.put(`/api/v1/parts/${partId}`, partData);
    return response.data;
  },
};

export default partsApi;
